
import { useState } from "react";
import { SignInForm } from "@/components/auth/SignInForm";
import { SignUpForm } from "@/components/auth/SignUpForm";
import { AuthFormLayout } from "@/components/auth/AuthFormLayout";

export default function Auth() {
  const [isSignUp, setIsSignUp] = useState(false);

  return (
    <AuthFormLayout
      title={isSignUp ? "Create an account" : "Welcome back"}
      description={
        isSignUp
          ? "Enter your details to create your account"
          : "Enter your credentials to sign in"
      }
    >
      {isSignUp ? (
        <SignUpForm onToggleMode={() => setIsSignUp(false)} />
      ) : (
        <SignInForm onToggleMode={() => setIsSignUp(true)} />
      )}
    </AuthFormLayout>
  );
}
